/**
 * my-templa 我的模板
 */
import {
  Method,
  Mode
} from '../core';
import {
  API,
  LOCAL,
  SOURCE
} from '../config';

const api = API;

export default {
  // 我的模板 list
  templateList: {
    url: `${api}/rest/v1/template/query`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      templateName: {
        $type: String
      },
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      }
    }
  },
  // 获取文档下载url
  downloadTemplate: {
    url: `${api}rest/v1/template/download`,
    method: Method.GET,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      templateId: {
        $type: String,
        $required: true
      }
    }
  },
  // 删除模板
  deleteTemplate: {
    url: `${api}/rest/v1/template/delete`,
    method: Method.DELETE,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      },
      templateId: {
        $type: String,
        $required: true
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/myTemp.js